import {
  any, boolean, date, nullable,
  string,
} from '@sda/sdk/helpers/types.bitmasks';

export const PrivateInvitationMask = {
  accepted: boolean,
  acceptedAt: date | nullable,
  acceptedBy: string | nullable,
  acceptedByName: string | nullable,
  actId: string | nullable,
  lastSentAt: date,
  revoked: boolean,
  revokedAt: date | nullable,
  showId: string | nullable,
  to: string,
  venueId: string | nullable,

  createdAt: date,
  collaborators: any,
  owner: string,
  updatedAt: date,
};
